import mediaSlices, { type MediaSlices } from './slices';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const devtoolsInstance = devtools(mediaSlices, { name: 'useMediaStore' });

const useMediaStore = create<MediaSlices, [['zustand/devtools', never]]>(
  devtoolsInstance
);

export default useMediaStore;
